!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
      ? define(t)
      : ((e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}), (e.ReactIntlLocaleData.nn = t()));
})(this, function () {
  'use strict';
  return [
    {
      locale: 'nn',
      pluralRuleFunction: function (e, t) {
        return t ? 'other' : 1 == e ? 'one' : 'other';
      },
      fields: {
        year: {
          displayName: 'år',
          relative: { 0: 'i år', 1: 'neste år', '-1': 'i fjor' },
          relativeTime: {
            future: { one: 'om {0} år', other: 'om {0} år' },
            past: { one: 'for {0} år sidan', other: 'for {0} år sidan' }
          }
        },
        'year-short': {
          displayName: 'år',
          relative: { 0: 'i år', 1: 'neste år', '-1': 'i fjor' },
          relativeTime: {
            future: { one: 'om {0} år', other: 'om {0} år' },
            past: { one: 'for {0} år sidan', other: 'for {0} år sidan' }
          }
        },
        month: {
          displayName: 'månad',
          relative: { 0: 'denne månaden', 1: 'neste månad', '-1': 'førre månad' },
          relativeTime: {
            future: { one: 'om {0} månad', other: 'om {0} månadar' },
            past: { one: 'for {0} månad sidan', other: 'for {0} månadar sidan' }
          }
        },
        'month-short': {
          displayName: 'mnd.',
          relative: { 0: 'denne månaden', 1: 'neste månad', '-1': 'førre månad' },
          relativeTime: {
            future: { one: 'om {0} md.', other: 'om {0} md.' },
            past: { one: 'for {0} md. sidan', other: 'for {0} md. sidan' }
          }
        },
        day: {
          displayName: 'dag',
          relative: { 0: 'i dag', 1: 'i morgon', 2: 'i overmorgon', '-2': 'i førgår', '-1': 'i går' },
          relativeTime: {
            future: { one: 'om {0} døgn', other: 'om {0} døgn' },
            past: { one: 'for {0} døgn sidan', other: 'for {0} døgn sidan' }
          }
        },
        'day-short': {
          displayName: 'dag',
          relative: { 0: 'i dag', 1: 'i morgon', 2: 'i overmorgon', '-2': 'i førgår', '-1': 'i går' },
          relativeTime: {
            future: { one: 'om {0} d.', other: 'om {0} d.' },
            past: { one: 'for {0} d. sidan', other: 'for {0} d. sidan' }
          }
        },
        hour: {
          displayName: 'time',
          relative: { 0: 'denne timen' },
          relativeTime: {
            future: { one: 'om {0} time', other: 'om {0} timar' },
            past: { one: 'for {0} time sidan', other: 'for {0} timar sidan' }
          }
        },
        'hour-short': {
          displayName: 't',
          relative: { 0: 'denne timen' },
          relativeTime: {
            future: { one: 'om {0} t', other: 'om {0} t' },
            past: { one: 'for {0} t sidan', other: 'for {0} t sidan' }
          }
        },
        minute: {
          displayName: 'minutt',
          relative: { 0: 'dette minuttet' },
          relativeTime: {
            future: { one: 'om {0} minutt', other: 'om {0} minutt' },
            past: { one: 'for {0} minutt sidan', other: 'for {0} minutt sidan' }
          }
        },
        'minute-short': {
          displayName: 'min',
          relative: { 0: 'dette minuttet' },
          relativeTime: {
            future: { one: 'om {0} min', other: 'om {0} min' },
            past: { one: 'for {0} min sidan', other: 'for {0} min sidan' }
          }
        },
        second: {
          displayName: 'sekund',
          relative: { 0: 'no' },
          relativeTime: {
            future: { one: 'om {0} sekund', other: 'om {0} sekund' },
            past: { one: 'for {0} sekund sidan', other: 'for {0} sekund sidan' }
          }
        },
        'second-short': {
          displayName: 'sek',
          relative: { 0: 'no' },
          relativeTime: {
            future: { one: 'om {0} sek', other: 'om {0} sek' },
            past: { one: 'for {0} sek sidan', other: 'for {0} sek sidan' }
          }
        }
      }
    }
  ];
});
